import { Ajax } from './axios'
import md5 from '../utils/md5'

export default {
  model: 'user',
  sendVcode (phoneNumber, smsType) {
    let param = { phoneNumber, smsType }
    const davinciKey = 'davinci.grade'
    const nonceStr = new Date().getTime() % 100000
    const sign = md5(nonceStr + davinciKey)
    const authSign = md5(`nonceStr=${nonceStr}&phoneNumber=${phoneNumber}&smsType=${smsType}&key=${davinciKey}`)
    let header = {
      "org": '21188075522202009676dfd1c0522d42',
      "nonceStr": nonceStr,
      "sign": sign,
      "authSign": authSign || "",
      "token": ""
    }
    return Ajax.post(`/api/gugongExaminee/v1/user/authcode`, param, { headers: header })
  },
  loginByVcode (mobile, vcode) {
    return Ajax.post(`/api/gugongExaminee/v1/${this.model}/login`, { userAccount: mobile, authCode: vcode, loginType: 1 })
  },
  loginByPass (userAccount, password) {
    return Ajax.post(`/api/gugongExaminee/v1/${this.model}/login`, { userAccount, password, loginType: 0 })
  },
  resetPass (mobile, vcode, newPass) {
    return Ajax.post(`/api/gugongExaminee/v1/${this.model}/resetPass`, { mobile, vcode, newPass })
  },
  // 修改证件照
  changeOfficialPhotoPUT (officialPhoto) {
    return Ajax.put(`/api/gugongExaminee/v1/${this.model}/changeOfficialPhoto`,{officialPhoto: officialPhoto});
  },
  // 证件照转换
  convertOfficialPhotoPOST (officialPhoto) {
    return Ajax.post(`/api/gugongExaminee/v1/${this.model}/convertOfficialPhoto`,{officialPhoto: officialPhoto});
  }
}
